import * as preact from "preact";

import ReaderReviewSessionView from "views/ReaderReviewSessionView";

export const name = "readerReview";
export const showHeader = false;

let containerElement = undefined;

export const render = async (element, renderedCallback, appRouter, options) => {
  element.empty();
  preact.render(
    <ReaderReviewSessionView
      bookID={options.bookID}
      position={options.position}
      appRouter={appRouter}
      returnPosition={options.returnPosition}
    />,
    element[0]
  );
  containerElement = element[0];

  renderedCallback();
};

export const close = () => {
  // Render an empty div to force unmounting of the component
  preact.render(null, containerElement);
  containerElement = undefined;
};
